import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, X } from "lucide-react";
import { errMsg } from "@/lib/api";
import { uploadSiteImage, imgUrl } from "@/lib/siteNews";

const useUpload = (onDone) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = () => ref.current?.click();
  const input = (
    <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif" hidden
      onChange={async (e) => {
        const f = e.target.files?.[0];
        e.target.value = "";
        if (!f) return;
        setBusy(true);
        try { onDone(await uploadSiteImage(f)); } catch (err) { toast.error(errMsg(err)); }
        setBusy(false);
      }} />
  );
  return { pick, input, busy };
};

export const ImageField = ({ value, onChange, testid, label = "Picture" }) => {
  const up = useUpload((r) => onChange(r.id));
  return (
    <div data-testid={testid}>
      <div className="mb-1 text-xs text-[#A8A090]">{label}</div>
      {value ? (
        <div className="relative w-fit">
          <img src={imgUrl(value)} alt="" className="max-h-40 rounded border border-[#2D3442]" data-testid={`${testid}-preview`} />
          <button onClick={() => onChange(null)} className="absolute right-1 top-1 rounded-full bg-black/70 p-1 text-white hover:bg-black" data-testid={`${testid}-remove`}><X className="h-3 w-3" /></button>
        </div>
      ) : (
        <button onClick={up.pick} disabled={up.busy} className="flex items-center gap-1.5 rounded border border-dashed border-[#2D3442] px-3 py-2 text-xs text-[#E8DFD1] hover:border-[#D97706]/60" data-testid={`${testid}-upload`}>
          <ImagePlus className="h-4 w-4" />{up.busy ? "Uploading…" : "Upload picture"}
        </button>
      )}
      {up.input}
    </div>
  );
};

export const InsertImageButton = ({ editor, testid }) => {
  const up = useUpload((r) => editor?.chain().focus().insertContent([{ type: "image", attrs: { src: r.url } }, { type: "paragraph" }]).run());
  return (
    <>
      <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={up.pick} disabled={up.busy} title="Insert picture" className="flex items-center gap-1 rounded px-2 py-1 text-xs text-[#E8DFD1] hover:bg-[#1A202C]" data-testid={testid}>
        <ImagePlus className="h-4 w-4" />{up.busy ? "Uploading…" : "Picture"}
      </button>
      {up.input}
    </>
  );
};
